import React from 'react';
import NavStore from 'stores/NavStore';
import AuthStore from 'stores/AuthStore';
import ActiveBalloon from 'components/nav/renderers/decorators/ActiveBalloon';
import connectToStores from 'alt-utils/lib/connectToStores';

class MentionRendererContainer extends React.Component {
  static getStores() {
    return [NavStore, AuthStore];
  }

  static getPropsFromStores() {
    return {
      inboxMentionsCount: NavStore.getState().inboxMentionsCount,
      sessionUser: AuthStore.getState().user,
    };
  }

  render() {
    return <MentionRendererImpl {...this.props} />;
  }
}

class MentionRendererImpl extends React.Component {
  registerPopoverItem(anchorEl, content) {
    if (this.popoverContainer) {
      this.popoverContainer.registerPopoverItem(anchorEl, content);
    }
  }

  render() {
    const {className, inboxMentionsCount, children, onClick} = this.props;

    return (
      <div className={className} onClick={onClick}>
        {inboxMentionsCount > 0 ? (
          <ActiveBalloon
            popoverText={`You have ${inboxMentionsCount} unread mention${
              inboxMentionsCount > 1 ? 's' : ''
            }.`}>
            {children}
          </ActiveBalloon>
        ) : (
          children
        )}
      </div>
    );
  }
}

export const MentionRenderer = connectToStores(MentionRendererContainer);
